// Internal
import { SubscriptionInviteStatus } from '../values/subscriptions.values.service';
import { GroupRoles } from './subscriptions/Groups.model';

export enum ServiceType {
    SUBSCRIPTION = 'subscription',
    LICENSE = 'license'
}

export class BundleModel {
    compatible_services?: string[];
    service_id: string;
    service_type: string;
    type: string;
    life_cycle: string;
    commercial_id: string;
    created: number;
    metadata?: {
        billing_cycle: number,
        billing_date: number,
        billing_cycle_price: number,
        billing_period?: string,
        currency: string,
        platform_currency?: string,
        platform_name?: string,
        platform_account?: string,
        platform_subscription_id?: string,
        platform_sub_start_date?: number,
        platform_term_start_date?: number,
        platform_renewal_number?: number,
        auto_renew?: boolean
    };
    end_date: number;
    bundle_id: string;
    bundle_friendly_name: string;
    max_shares?: number;
    slots: number;
    applications: AppModel[];
    status: string;
    accounts: any[];
    active_slots: number;
    server_time: number;
    interface: {
        buttons: any;
        links: any,
        allocation: any,
        name: string;
        renewalDate: number;
        renewalDateLocale: string;
        billingDateLocale: string;
        endDateLocale: string;
        price: number;
        currency: string;
        daysRemaining: number;
        devices: string[],
        totalDevices: number;
        expired: boolean;
        unlimitedSlots:boolean;
        image: string;
        mainDesc:string;
        description: string;
        type: string;
        serviceType: string;
        serviceTypeLocal: string;
        life_cycle: string;
        desc: string;
        end_date: number;
        billing_cycle?: string;
        buyOrRenew?: any;
        hideEndDate?: boolean;
        startPlan?: any;
        personalPlan?: any;
        familyPlan?: any;
        ultimatePlan?: any;
        install?: any;
        expiryAndUsage?: any;
        badge?: any;
        manageButtons?: any;
        details?: any;
        invites?: SharedSubscriptionInvitesInfo;
        familyProfiles?: SharedSubscriptionProfilesInfo;
        convert?: {
            features?: string[];
            newBillingDate?: string;
        };
        protectionApps?: any,
    };
    devicesShownIds?: string[];
    devicesRemovedIds?: string[];
    devices?: DeviceModel[];
    manageButtons?: ManageButtonModel[];
    newEndDate?: number;
    oldEndDate?: number;
    endingInExtendService?: number;
    endingInNewService?: number;
    endDateFormatted?: string;
    check?: any;
    plan_name?: string;
    group_type?: string;
    group_id?: string;
    strings?: any;
    processed: any;
    source?: any;
    isSinglePlatformSubscription: boolean;
    isMultiPlatformSubscription: boolean;
}

export type BundleApps = AppModel[];

export class LinksServiceModel {
    features?: string;
    systemRequirements?: string;
    userGuide?: string;
    website?: string;
}

export class AppModel {
    app_id: string;
    countable: number;
    slots: {
        max: number;
        min: number;
    };
    app_params?: {
        level: string;
        connections?: number;
    };
    commercial_id_info?: {
        buyts_url: string;
    };
    interface?: any;
    devices?: DeviceModel[];
    nameToBeDisplayed?: any;
    numberOfDevices?: number;
    os?: string;
    icon?: string;
    check?: any;
    installIncentive?: any;
    strings?: any;
}

export class RedeemConfirmationModel {
    extended?: boolean;
    alreadyActive?: boolean;
    scenario?: string;
    discountPercentage?: number;
    newEndDate?: number;
    profileHash?: string;
    deviceId?: string;
    redeemResponse?: RedeemDataModel;
}

export class RedeemConfirmationCongratsScenarioModel {
    title?: string;
    subtitle?: string;
    description?: string;
    benefits?: Array<string>;
    footerContent?: {
        text?: string;
        placeholders?: any;
    };
}

export class UsageSummary {
    app_id: string;
    slot_id: string;
    countable: string;
}

export class MacVendorModel {
    mac: string;
    vendor: string;
}

export class ProtectionStatusModel {
    issues: number;
    protected: number;
    protection_app: string;
}

export class SubscriptionInfoModel {
    commercial_id: string;
    free_slots: number;
    remaining_days: number;
    type: string;
}

export interface ISharedSubscriptionInfo {
    hasSharedSubscription: boolean;
    isPayer: boolean;
    payerEmail: string;
    payerName?: string;
    showAlert?: boolean;
    isSecondaryUser?: boolean;
}

export interface SharedSubscriptionSharedInfo {
    isShared?: boolean, // used with zuora
    payer: any
    gainer : any,
    isPayer: boolean,
    gainers: Array<any>,
    isAdmin: boolean // used with groupManagement
}

export interface SharedSubscriptionInvite {
    member_id?: string,
    profile_id?: string,
    email: string,
    sanitizedEmail?: string,
    name?: string,
    role?: GroupRoles,
    member_label?: string,
    status?: SubscriptionInviteStatus, // this should be invite_accepted: true / false / undefined??
    // non groupmanaged (for now)
    inviteId?: string,
    inviteLink?: string,
    markedToBeRemoved?: boolean,
    shareId?: string,
    isBusinessOwner?: boolean,
    groupId?: string
}

export interface SharedSubscriptionInvitesInfo {
    manageInvites: Array<SharedSubscriptionInvite>,
    availableInvites: number
}

export interface SharedSubscriptionProfile {
    name: string,
    profileHash: number,
    profileId: string,
    type: string
};

export interface SharedSubscriptionProfilesInfo {
    manageProfiles: Array<SharedSubscriptionProfile>,
    availableProfiles: number
};

export class DeviceModel {
    agent_detected_name?: string;
    agent_status?: number;
    apps?: AppModel[];
    box_managed?: number;
    created?: number;
    device_account_sid?: number;
    device_icon?: string;
    device_id?: string;
    device_os?: string;
    device_state?: string;
    device_type?: string;
    display_name?: string;
    install_agent?: number;
    mac_vendor?: MacVendorModel;
    macs?: number[];
    profile_id?: number;
    processed?: any;
    protection_status?: ProtectionStatusModel;
    subscription_info?: SubscriptionInfoModel;
    current_bundle?: BundleModel;
    bundles_on_change?: BundleModel[];
    removed?: boolean;
}

export class BundlesServicesModel {
    license: BundleModel[];
    subscription: BundleModel[];
}

export class ManageButtonModel {
    button_name: string;
    modal_name?: string;
    action?: string;
}

export class InvoiceModel {
    id: string;
    accountId: string;
    accountNumber: string;
    accountName: string;
    invoiceDate: string;
    invoiceNumber: string;
    dueDate: string;
    invoiceTargetDate: string;
    amount: number;
    balance: number;
    creditBalanceAdjustmentAmount: number;
    createdBy: string;
    status: string;
    reversed: boolean;
    body: string;
    CollectionStatus__c: string;
    CollectionDate__c: string;
    InvoiceType__c: string;
    invoiceItems: string;
    invoiceFiles: string;
}

export class DeviceAllocationMgmtResponseModel {
    id: number;
    jsonrpc: string;
    result: {
        status: number;
    };
}

export class WantedServiceModel {
    service_id: string;
    device_id: string;
    app_ids: string[];
}

export class SubscriptionStatesModel {
    upgradable: boolean;
    ending: boolean;
    expired: boolean;
    notContinous: boolean;
}

export class RenewalInfoModel {
    Email: string;
    MerchantCode: string;
    AvangateAccount: string;
    SubscriptionReference: string;
    ExpirationDate: string|number;
    RecurringEnabled: boolean;
    ProductName: string;
    AvangateProductId: string;
    WebgenProductId: number;
    BundleId: string;
    BundleIcon?: string;
    NeedsAuthorization?: boolean;
}

export class IFrameRequestDetailsModel {
    sub_id: string;
    account: string;
}

export class ZuoraConfigObject {
    key: string;
    country: string;
    debug: boolean;
    element: string;
    return_url: string;
    default_scenario: string;
}

export interface RedeemDataModel {
    personal?: BundleModel;
    contexts?: EligibleServicesContextService[],
    reason?: string,
    data?: BundleModel,
    status?: number;
    endDateFormatted?: any;
    image?: string;
    daysRemaining?: any;
    bundle_id?: string;
    serviceTypeLocal?: any;
    hideEndDate?: any;
    server_time?: number;
    service_id?: string;
}

export enum AppConfigurationStatus {
    INSTALLED = 'installed',
    NOT_INSTALLED = 'notInstalled',
    CONFIGURED = 'configured',
    NOT_CONFIGURED = 'notConfigured',
    PENDING = 'pending'
}

export enum AllocationCases {
    LIMIT_REACHED = 'limitReached',
    ABOVE_INTERMIDIATE = 'aboveIntermidiate',
    ABOVE_INTERMIDIATE_BOX = 'aboveIntermidiateBox',
    UNDER_INTERMIDIATE = 'underIntermidiate',
    MORE_THAN_ONE = 'moreThanOne',
    ONE = 'one',
    ZERO = 'zero'
}

export enum DeviceAllocationDisplayComponents {
    STEP1_HEADER = 'step1header',
    STEP2_REMOVE = 'step2remove',
    STEP2_USAGE = 'step2usage',
    STEP2_WILL_HAVE = 'step2willHave',
    STEP2_WILL_HAVE_SINGLE = 'step2willHaveSingle',
    STEP2_WILL_HAVE_MULTI = 'step2willHaveMulti',
    USED_BY_BOX = 'usedByBox',
    SERVICE_WILL_END = 'serviceWillEnd'
}
export class DeviceAllocationDisplayByServiceTypeCell {
    [ServiceType.LICENSE]: string;
    [ServiceType.SUBSCRIPTION]?: string;
}
export class DeviceAllocationDisplayCell {
    [DeviceAllocationDisplayComponents.STEP1_HEADER]: DeviceAllocationDisplayByServiceTypeCell;
    [DeviceAllocationDisplayComponents.STEP2_REMOVE]: DeviceAllocationDisplayByServiceTypeCell;
    [DeviceAllocationDisplayComponents.STEP2_USAGE]: DeviceAllocationDisplayByServiceTypeCell;
    [DeviceAllocationDisplayComponents.STEP2_WILL_HAVE]?: DeviceAllocationDisplayByServiceTypeCell;
    [DeviceAllocationDisplayComponents.STEP2_WILL_HAVE_SINGLE]?: DeviceAllocationDisplayByServiceTypeCell;
    [DeviceAllocationDisplayComponents.STEP2_WILL_HAVE_MULTI]?: DeviceAllocationDisplayByServiceTypeCell;
    [DeviceAllocationDisplayComponents.USED_BY_BOX]: DeviceAllocationDisplayByServiceTypeCell;
    [DeviceAllocationDisplayComponents.SERVICE_WILL_END]: DeviceAllocationDisplayByServiceTypeCell;
}
export class ServiceApplicationsDevicesAllocationCases {
    [AllocationCases.LIMIT_REACHED]: string;
    [AllocationCases.ABOVE_INTERMIDIATE]: string;
    [AllocationCases.ONE]: string;
    [AllocationCases.UNDER_INTERMIDIATE]: string;
    [AllocationCases.ZERO]: string;
}
export class ServiceDevicesAllocationCases {
    [AllocationCases.LIMIT_REACHED]: DeviceAllocationDisplayCell;
    [AllocationCases.ABOVE_INTERMIDIATE]: DeviceAllocationDisplayCell;
    [AllocationCases.ABOVE_INTERMIDIATE_BOX]: DeviceAllocationDisplayCell;
    [AllocationCases.ONE]: DeviceAllocationDisplayCell;
    [AllocationCases.UNDER_INTERMIDIATE]: DeviceAllocationDisplayCell;
    [AllocationCases.ZERO]: DeviceAllocationDisplayCell;
}
export class ServiceSlotsAllocationCases {
    [AllocationCases.LIMIT_REACHED]: ServiceDevicesAllocationCases;
    [AllocationCases.MORE_THAN_ONE]: DeviceAllocationDisplayCell;
    [AllocationCases.ONE]: DeviceAllocationDisplayCell;
}

export interface EligibleServicesContextService {
    context_id: string;
    service: BundleModel;
    compatibilityStatus?: string;
}
